import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

const Nav = ({items, activeItem, handleItemClick}) => {
  return (
    <div id="nav-wrapper">
      <Menu inverted fluid widths={items.length} stackable>
        { items.map((item, i) => (
          <Menu.Item key={i} as={Link} to={item.value} name={item.value} value={item.text} active={activeItem === item.value} onClick={handleItemClick}>
            { item.text }
          </Menu.Item>
        )) }
      </Menu>
    </div>
  );
}



export default Nav;


// WEBPACK FOOTER //
// ./src/components/Nav.js